import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { loader, p } from "~/misc/common";
import QrScanner from "qr-scanner";
import { createConsumer } from "@rails/actioncable";

export default class extends Controller {
	async connect() {
		p('initQrApp');
		const el = this.element as HTMLDivElement;

		const video = document.getElementById("preview") as HTMLVideoElement;

		let mirrored = false;
		function refreshMirror() {
			mirrored ? $('#flip').addClass('active') : $('#flip').removeClass('active');
			video.style.transform = mirrored ? 'scaleX(-1)' : '';
		}
		$('#flip').on('click', function () {
			$('#flip').blur();
			mirrored = !mirrored;
			refreshMirror();
		});
		refreshMirror();

		const scanner = new QrScanner(
			video,
			onScan,
			{
				highlightScanRegion: true,
				highlightCodeOutline: true,
			}
		);

		const cameras = await QrScanner.listCameras(true);
		let currentCamera = cameras.findIndex(c =>
			c.label.toLowerCase().includes('back')
		);
		if (currentCamera < 0) currentCamera = 0;

		if (cameras.length > 0) {
			scanner.setCamera(cameras[currentCamera].id);
			scanner.start();
			if (cameras.length > 1) {
				$('#change').show(300);
			}
		} else {
			p('No cameras found.');
		}

		let last: string | null = null;
		let timeout: number | null = null;
		function onScan(result: QrScanner.ScanResult) {
			const content = result.data;
			if (last !== content) {
				last = content;
				onNewData(content);
			}
			if (timeout) clearTimeout(timeout);
			timeout = setTimeout(() => { last = null; }, 1000);
		}

		function onNewData(content: string) {
			p(content);
			($('#beep')[0] as HTMLAudioElement).play();
			const y = $('#x_y').myGetNumValue();
			if (y == 2) {
				p('Sending on ActionCable');
				connection.send({
					action: 'qr',
					data: content
				});
				//connection.perform('qr', content);
			} else {
				let url: string | null = null;
				if (content.startsWith('GR')) {
					url = '/group_reports/' + content.replace('GR', '');
				} else if (content.startsWith('MR')) {
					url = '/mission_reports/' + content.replace('MR', '');
				} else if (content.startsWith('CT')) {
					url = '/contracts/' + content.replace(/CTC|CTA|CTJ|CTI|CTS|CTM/, '');
				} else if (content.startsWith('TRN')) {
					url = '/trainings/' + content.replace('TRN', '') + '/attendance';
				}
				if (url) {
					if (!y) {
						loader(true);
						window.open(url, '_self');
					} else if (y == 1) {
						window.open(url, '_blank');
					} else if (y == 3) {
						if (url.startsWith('/group_reports')) {
							p('Getting Bellarmin link');
							$.get(url + '/ba_url', function (data) {
								p(data);
								window.open(data.url, '_blank');
							}).fail(function () {
								alert('Nem található ilyen adatlap!');
							});
						} else {
							alert('Ez nem egy adatszolgáltatás QR kódja.');
						}
					}
				} else {
					alert('Nem a rendszer generálta a QR kódot. (' + content + ')');
				}
			}
		}

		$('#change').on('click', async function () {
			$('#change').blur();
			if (cameras.length <= 1) return;

			try {
				currentCamera = (currentCamera + 1) % cameras.length;
				await scanner.setCamera(cameras[currentCamera].id);
				p('Switched camera to: ' + cameras[currentCamera].label);
				// Optional: auto-mirror front cameras
				const label = cameras[currentCamera].label.toLowerCase();
				mirrored = label.includes('front');
				refreshMirror();
			} catch (e) {
				console.error(e);
				alert('Failed to switch camera.');
			}
		});

		const user_id = el.dataset.userid!;
		const connection = createConsumer().subscriptions.create(
			{ channel: 'AndroidChannel', id: user_id },
			{
				connected() {
					p('connected');
					connection.send({
						action: 'qr',
						discovery_answer: true
					});
					//this.perform('really_subscribed');
				},
				disconnected() {
					p('disconnected');
				},
				received: (data: any) => {
					p(data);
					switch (data.action) {
						case 'qr':
							if (data.msg.discovery_question) {
								connection.send({
									action: 'qr',
									discovery_answer: true
								});
							}
							break;
					}
				},
			}
		);
	}
}